import { IconProps } from "./study-icon";

export const PracticeTestIcon: React.FC<IconProps> = ({ size = 19, className, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 17 19'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className={className}
		{...rest}
	>
		<path
			d='M5.615 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H11C11.5304 1 12.0391 1.21071 12.4142 1.58579C12.7893 1.96086 13 2.46957 13 3V11M10 16L12 18L16 14M5 5H9M5 9H7'
			stroke='currentColor'
			strokeWidth={1.5}
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)